/**
 * Builds the Planhat EndUser externalId for the current user + instance.
 *
 * MUST stay byte-for-byte identical to the value instance-service writes in
 * `src/planhat/mappers.ts` (mapLoginUserToPlanhatEnduser):
 *   externalId: `${user.Id.toLowerCase()}__${subDomain}`
 *
 * Any drift here makes activities create duplicate orphan EndUsers in Planhat
 * instead of matching the record the nightly sync already created.
 */
export function buildEnduserExternalId(loginUserId: string, subDomain: string): string {
    return `${loginUserId.toLowerCase()}__${subDomain}`;
}
